/**
 * Build admin panel URLs from the storefront app.
 */
export function getAdminPanelUrl(): string {
  const fromEnv = import.meta.env.VITE_ADMIN_URL as string | undefined
  if (fromEnv?.trim()) {
    return fromEnv.trim().replace(/\/$/, '')
  }

  const { protocol, hostname, port } = window.location
  // Local dev: storefront :3000, admin :3001
  if (port === '3000') {
    return `${protocol}//${hostname}:3001`
  }

  return `${protocol}//${hostname}${port ? `:${port}` : ''}/admin`
}
